import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { Lookup } from 'devextreme-react/lookup';
import './profile.scss';
import TextBox from 'devextreme-react/text-box';
import { Button } from 'devextreme-react/button';
import { Popover } from 'devextreme-react/popover';
import { Popup } from 'devextreme-react/popup';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages} from 'devextreme/localization';
import DataGrid, {
  Column,
  DataGridTypes,
  Pager,
  Paging,
  Search,
  ColumnChooser,
  Export,
  HeaderFilter,
  LoadPanel,
  GroupPanel,
  Grouping, Sorting,
} from 'devextreme-react/data-grid';
import Chart, {ArgumentAxis,Legend,Series,Label} from 'devextreme-react/chart';
import {SelectBox, SelectBoxTypes} from 'devextreme-react/select-box';
import {RangeSelector, Margin, Scale, SliderMarker} from 'devextreme-react/range-selector';
import Moment from 'moment';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import DataSource from 'devextreme/data/data_source';
import { DateBox } from 'devextreme-react/date-box';
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom"
import Cookies from 'universal-cookie';
import PollResults from './PollResults';
import SurveyChecker from './SurveyChecker';


export default function Profile() {
  const currentDate = new Date();
  const defaultStartDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 14);
  const defaultEndDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

  const date = Moment().add(-14,'days').format('YYYY,MM,DD');
  const dateend = Moment().format('YYYY,MM,DD');
  const datego = Moment().format('YYYY');
  const cookies = new Cookies();
  const [news, setNews] = useState(null);
  const [newsLoading, setNewsLoading] = useState(true);

  const [status, SetStatus] = useState(true);

  //текущий опрос
const [pollStats, setPollStats] = useState(null);
const [pollStatsLoading, setPollStatsLoading] = useState(false);
const [eatingChildrenCount, setEatingChildrenCount] = useState(null);


  //Проверка доступности сервера
  function getserverstatus() {
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 7000)

    return fetch('https://api.cemon.ru/status', { signal: controller.signal })
        .then((response) => response.json())
        .then((responseJson) => {
          if(responseJson[1].Порядок>0){SetStatus(true);getListregion()}else{SetStatus(false);}

        })
        .catch((error) => {
          SetStatus(false);
        });
  }

  const getPollStatistics = useCallback(async (foodBlockCode) => {
  if (!foodBlockCode) return;
  
  setPollStatsLoading(true);
  try {
    const response = await fetch(`https://apiopros2026.cemon.ru/api/foodblock/${foodBlockCode}/stats`);
    const data = await response.json();
    
    console.log('Poll stats response:', data); // Для отладки
    
    if (data.success && data.data) {
      setPollStats(data.data);
      
      // Извлекаем количество питающихся из external_api
      const eatingCount = data.data?.external_api?.cemon_ru?.data?.Питаются;
      console.log('Eating children count:', eatingCount); // Для отладки
      
      if (eatingCount && typeof eatingCount === 'number' && eatingCount > 0) {
        setEatingChildrenCount(eatingCount);
      } else {
        setEatingChildrenCount(null);
      }
    } else {
      setPollStats(null);
      setEatingChildrenCount(null);
    }
  } catch (error) {
    console.error('Ошибка получения статистики опроса:', error);
    setPollStats(null);
    setEatingChildrenCount(null);
  } finally {
    setPollStatsLoading(false);
  }
}, []);

const getEatingChildrenCount = useCallback(async (foodBlockCode) => {
  if (!foodBlockCode) return;
  
  
  try {
    // Используем тот же API, что и для статистики, чтобы получить external_api данные
    const response = await fetch(`https://apiopros2026.cemon.ru/api/foodblock/${foodBlockCode}/stats`);
    const data = await response.json();
    
    // Данные о питающихся находятся в data.data.external_api.cemon_ru.data.Питаются
    if (data?.data?.external_api?.cemon_ru?.data?.Питаются) {
      setEatingChildrenCount(data.data.external_api.cemon_ru.data.Питаются);
    } else {
      setEatingChildrenCount(null);
    }
  } catch (error) {
    console.error('Ошибка получения данных о питающихся:', error);
    setEatingChildrenCount(null);
  } finally {
 
  }
}, []);

const loadNews = useCallback(async () => {
  setNewsLoading(true);
  try {
    const response = await fetch('https://api.cemon.ru/news.json');
    const data = await response.json();
    setNews(data);
  } catch (error) {
    console.error('Ошибка загрузки новостей:', error);
    setNews(null);
  } finally {
    setNewsLoading(false);
  }
}, []);



  //Получение get-параметра
  const location = useLocation();
  const params = new URLSearchParams(location.search)

  useEffect(() => {
    if(params.get("id")>0){
      cookies.set('id', params.get("id"), { path: '/' });
    }
    getserverstatus();
    loadNews();
    getEatingChildrenCount(selectpisheblok)

  }, []);


const renderNutrientCell = (value) => {
  if (!value) return <div>-</div>;

  // Извлекаем числовое значение из строки
  const match = value.match(/\(([^)]+)\)/);
  const numericValue = match ? parseFloat(match[1].replace(',', '.')) : null;
  
  // Определяем статус
  let status = 'normal';
  if (value.includes('выше нормы')) status = 'above';
  if (value.includes('ниже нормы')) status = 'below';
  
  return (
    <div className={`nutrient-cell ${status}`}>
      <div className="nutrient-value">
        {numericValue ? numericValue.toFixed(1) : '-'}
      </div>
      <div className="nutrient-status">
        {value.replace(/\([^)]+\)/, '').trim()}
      </div>
    </div>
  );
};

const renderNewsBlock = () => {
  if (newsLoading) {
    return (
      <div className="dx-card" style={{ padding: '8px 12px', backgroundColor: '#f8f9fa' }}>
        <span style={{ fontSize: '13px', color: '#666' }}>Загрузка...</span>
      </div>
    );
  }
  
  if (!news) return null;
  
  // Фильтруем активные объявления
  let newsItems = Array.isArray(news) ? [...news] : [news];
  newsItems = newsItems.filter(item => item.active !== false);
  
  if (newsItems.length === 0) return null;
  
  // Сортируем по приоритету (high → medium → low)
  const priorityOrder = { high: 0, medium: 1, low: 2 };
  newsItems.sort((a, b) => {
    return (priorityOrder[a.priority] || 3) - (priorityOrder[b.priority] || 3);
  });
  
  // Определяем самый высокий приоритет для общего оформления
  const highestPriority = newsItems[0]?.priority || 'low';
  const priorityConfig = {
    high: { bgColor: '#fff2f0', borderColor: '#d9534f', icon: '⚠️', title: 'ВАЖНЫЕ ОБЪЯВЛЕНИЯ' },
    medium: { bgColor: '#fff9e6', borderColor: '#ff9800', icon: 'ℹ️', title: 'ОБЪЯВЛЕНИЯ' },
    low: { bgColor: '#f0f7ff', borderColor: '#5bc0de', icon: '📢', title: 'ИНФОРМАЦИЯ' }
  };
  const config = priorityConfig[highestPriority];
  
  return (
    <div className="dx-card" style={{ 
      padding: '10px 12px',
      backgroundColor: config.bgColor,
      borderLeft: `4px solid ${config.borderColor}`,
      borderRadius: '4px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
        <span style={{ fontSize: '16px' }}>{config.icon}</span>
        <span style={{ fontWeight: 'bold', fontSize: '13px' }}>{config.title}</span>
      </div>
      
      {newsItems.map((item, idx) => (
        <div key={idx} style={{ 
          marginTop: idx > 0 ? '10px' : 0,
          paddingTop: idx > 0 ? '10px' : 0,
          borderTop: idx > 0 ? '1px solid rgba(0,0,0,0.05)' : 'none'
        }}>
          <div style={{ fontWeight: 'bold', fontSize: '13px', marginBottom: '4px' }}>
            {item.title}
          </div>
          <div style={{ fontSize: '12px', color: '#555', marginBottom: '4px' }}>
            {item.message || item.text || item.content}
          </div>
          {item.date && (
            <div style={{ fontSize: '10px', color: '#999' }}>
              📅 {item.date}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};



  //Задание временной шкалы
   const [startValue, setstartValue] = useState(new Date(currentDate.getFullYear(), 8, 1)); // 1 августа
  const [endValue, setendValue] = useState(new Date(currentDate.getFullYear() + 1, 7, 31)); // 31 июля следующего года
  
  //Задание промежутка
  const [range, setrange] = useState([defaultStartDate, defaultEndDate]);
  const [selectstart, setselectstart] = useState(date);
  const [selectend, setselectend] = useState(dateend);

  const getCurrentAcademicYear = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth(); // 0-11 (январь-декабрь)
    
    // Если август или позже (месяцы 7-11) - следующий учебный год
    if (currentMonth >= 7) {
      return currentYear + 1;
    } else {
      return currentYear;
    }
  };

  const [god, setgod] = useState(2026); // Изначальное значение

  const getgod = [
    {value: 2022, label: '2021-2022'},
    {value: 2023, label: '2022-2023'},
    {value: 2024, label: '2023-2024'},
    {value: 2025, label: '2024-2025'},
    {value: 2026, label: '2025-2026'},
    {value: 2027, label: '2026-2027'},   
  ];

  // useEffect для установки правильного года при загрузке
  useEffect(() => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();
  
  // Определяем текущий учебный год
  // Если сейчас январь-август 2026, то это учебный год 2025-2026
  // Если сентябрь-декабрь 2026, то это учебный год 2026-2027
  let academicYear;
  if (currentMonth >= 8) { // Сентябрь и позже
    academicYear = currentYear + 1;
  } else {
    academicYear = currentYear;
  }
  
  // Проверяем, есть ли такой год в списке
  const yearExists = getgod.some(item => item.value === academicYear);
  
  if (yearExists) {
    // Вызываем setinggod для установки всех дат
    setinggod({ value: academicYear });
  } else {
    // Берем последний доступный год
    const lastAvailableYear = getgod[getgod.length - 1].value;
    setinggod({ value: lastAvailableYear });
  }
}, []); // Только при монтировании

  const setinggod = useCallback(({ value }) => { 
  // value - это год окончания учебного года (например, 2026 для учебного года 2025-2026)
  setgod(value);
  
  // Учебный год: с 1 сентября предыдущего года по 31 августа текущего года
  const startOfAcademicYear = new Date(value - 1, 8, 1); // 1 сентября
  const endOfAcademicYear = new Date(value, 7, 31);      // 31 августа
  
  setstartValue(startOfAcademicYear);
  setendValue(endOfAcademicYear);
  
  // Диапазон по умолчанию: последние 14 дней (как в исходном коде)
  const currentDate = new Date();
  let defaultRangeStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 14);
  let defaultRangeEnd = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
  
  // Ограничиваем даты рамками учебного года
  if (defaultRangeStart < startOfAcademicYear) defaultRangeStart = startOfAcademicYear;
  if (defaultRangeEnd > endOfAcademicYear) defaultRangeEnd = endOfAcademicYear;
  
  // Если текущая дата вне учебного года, показываем начало учебного года
  if (currentDate < startOfAcademicYear) {
    defaultRangeStart = startOfAcademicYear;
    defaultRangeEnd = new Date(startOfAcademicYear.getTime() + 14 * 24 * 60 * 60 * 1000); // +14 дней
    if (defaultRangeEnd > endOfAcademicYear) defaultRangeEnd = endOfAcademicYear;
  } else if (currentDate > endOfAcademicYear) {
    defaultRangeEnd = endOfAcademicYear;
    defaultRangeStart = new Date(endOfAcademicYear.getTime() - 14 * 24 * 60 * 60 * 1000); // -14 дней
    if (defaultRangeStart < startOfAcademicYear) defaultRangeStart = startOfAcademicYear;
  }
  
  setrange([defaultRangeStart, defaultRangeEnd]);
  
  // Обновляем даты для запросов
  setselectstart(Moment(defaultRangeStart).format("YYYY,MM,DD"));
  setselectend(Moment(defaultRangeEnd).format("YYYY,MM,DD"));
  setkpgod(value); // Учебный год для календаря питания
}, []);
  


 

  //Руссификация сообщений
  locale(sessionStorage.getItem('locale') || 'ru');
  loadMessages(ruMessages);
  
//Загрузка списка регионов
const [listregion, setListRegion] = useState();
const getListregion = async (id) => {
  const response = await fetch(
    "https://api.cemon.ru/listregion/"
  ).then((response) => response.json());
  setListRegion(response);
  
};

    //Запрос пищеблоков по id региона
  const [pisheblok, setUsers] = useState();
  const getPisheblok = async (id) => {
    const response = await fetch(
      "https://api.cemon.ru/listpisheblok/?id="+id
    ).then((response) => response.json());
    setUsers(response);
    
  };

  const setlog = async (id) => {
    const response = await fetch(
        "https://api.cemon.ru/logs/analiz/?id="+id
    ).then((response) => response.text());


  };



  const groupedData = useMemo(
    () => new DataSource({
      store: pisheblok,
      key: 'value',
      group: 'rayon',
    })
    ,[pisheblok]
  );







  const ChangeRegion = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
    setSelectregion(e.value);
    getPisheblok(e.value);

  }, []);




  const ChangePisheblok = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
  cookies.set('id', e.value, { path: '/' });
  setSelectpisheblok(e.value);
  setlinkdata('https://api.cemon.ru/pishinfo?id='+e.value);
  
  // Сбрасываем данные при смене пищеблока
  setPollStats(null);
  setPollStatsLoading(false);
  setEatingChildrenCount(null);
}, []);


//Значение для полей поиска региона/пищеблока
        const [selectpisheblok, setSelectpisheblok] = useState();
        const [selectregion, setSelectregion] = useState();

  const valueChangedidpoisk = useCallback(({ value }) => {
    setiddlapoiska(value);
  }, []);




  const [newlink, setnewlink] = useState();
  const valueChangedlink = useCallback(({ value }) => {
    if(typeof String.prototype.trim !== 'function') {
      String.prototype.trim = function() {
        return this.replace(/^\s+|\s+$/g, '');
      }
    }
    setnewlink(value.trim());
  }, []);


  const [resulteditlink, setresulteditlink] = useState();


  const [iddlapoiska, setiddlapoiska] = useState();
  const [linkdata, setlinkdata] = useState();
  const [menudata, setmenudata] = useState();
  const [bzudata, setbzudata] = useState();
  const [menuinfo, setmenuinfo] = useState();


  const [popupVisible, setpopupVisible] = useState(false);

  const [menuVisible, setmenuVisible] = useState(false);
  const [menutitle, setmenutitle] = useState();
  const [menudataw, setmenudataw] = useState();

  const [menuVisiblesab, setmenuVisiblesab] = useState(false);
  const [menutitlesab, setmenutitlesab] = useState();
  const [menudatawsab, setmenudatawsab] = useState();
  const [menudatawsabb, setmenudatawsabb] = useState();
  const [menudatawsabbb, setmenudatawsabbb] = useState();

  const [linkdataerror, setlinkdataerror] = useState();
  const [chtenielog, setchtenielog] = useState();
  const [ocenki, setocenki] = useState();
  const [opros, setopros] = useState();


  const [sobludenietip, setsobludenietip] = useState();
  const [findex, setfindex] = useState();
  const [inn, setinn] = useState();
  const [coordina,setcoordina] = useState();
  const [kplink,setkplink] = useState();

  const [kpdate,setkpdate] = useState(' ');
  const [tpdata,settpdata] = useState();

  const [kpgod,setkpgod] = useState(datego);
  const [kpos,setkpos] = useState(0);

  // Состояние для отображения результатов опроса
  const [showPollResults, setShowPollResults] = useState(false);



  

const PoiskPoid = () => {

  if(iddlapoiska>0){
  const  response = fetch(
    "https://api.cemon.ru/pisheblokpoid?id="+iddlapoiska
  ).then(response => response.json())
  .then(data => { 
    setSelectpisheblok(data[0].value);
    setSelectregion(data[0].RegionID);
    setiddlapoiska('');
  })
  .catch(error => {console.error(error); setpopupVisible(true)});
  };
}

const PoiskPoidiscook = (id) => {
  const  response = fetch(
    "https://api.cemon.ru/pisheblokpoid?id="+id
  ).then(response => response.json())
  .then(data => { 
    setSelectpisheblok(data[0].value);
    setSelectregion(data[0].RegionID);
    setiddlapoiska('');
  })
  .catch(error => {console.error(error); setpopupVisible(true)});
}



const hideInfo = useCallback(() => {
  setpopupVisible(false);
  setiddlapoiska();

}, []);



const selectPeriod = useCallback((e: RangeSelector.ValueChangedEvent) => {
  const newRange = [
    new Date(e.value[0]),
    new Date(e.value[1])
  ];
  setrange(newRange);
  setselectstart(Moment(newRange[0]).format("YYYY,MM,DD"));
  setselectend(Moment(newRange[1]).format("YYYY,MM,DD"));
  setkpgod(Moment(newRange[1]).format("YYYY"));
}, []);

const selectPeriodn = useCallback((e) => {
  const newStart = new Date(e.value);
  const newRange = [newStart, range[1]];
  
  // Проверяем, чтобы начальная дата не была позже конечной
  if (newStart > range[1]) {
    newRange[1] = new Date(newStart);
  }
  
  setrange(newRange);
  setselectstart(Moment(newStart).format("YYYY,MM,DD"));
}, [range]);

const selectPeriodk = useCallback((e) => {
  const newEnd = new Date(e.value);
  const newRange = [range[0], newEnd];
  
  // Проверяем, чтобы конечная дата не была раньше начальной
  if (newEnd < range[0]) {
    newRange[0] = new Date(newEnd);
  }
  
  setrange(newRange);
  setselectend(Moment(newEnd).format("YYYY,MM,DD"));
}, [range]);







useEffect(() => {
  getserverstatus();
  console.clear();
  //Если в кукисах есть id пищеблока
  if (cookies.get('id') > 0) {
    PoiskPoidiscook(cookies.get('id'));
  }

  if (selectpisheblok > 0) {
    setlog(selectpisheblok);
    setmenudata('https://api.cemon.ru/menudata?id=' + selectpisheblok + '&n=' + selectstart + '&k=' + selectend);
    setbzudata('https://api.cemon.ru/bzu?id=' + selectpisheblok + '&n=' + selectstart + '&k=' + selectend);
    setlinkdataerror('https://api.cemon.ru/provarkamenu?id=' + selectpisheblok + '&n=' + selectstart + '&k=' + selectend);
    setocenki('https://api.cemon.ru/ocenki?id=' + selectpisheblok + '&n=' + selectstart + '&k=' + selectend);
    setopros('https://api.cemon.ru/opros/statpisheblok?code=' + selectpisheblok);
    setchtenielog('https://api.cemon.ru/logsread?id=' + selectpisheblok + '&n=' + selectstart + '&k=' + selectend);
    setsobludenietip('https://api.cemon.ru/sopostovlenie?id=' + selectpisheblok + '&n=' + selectstart + '&k=' + selectend);
    setfindex('https://api.cemon.ru/findex?id=' + selectpisheblok);
    setkplink('https://api.cemon.ru/kp/?id=' + selectpisheblok + '&g=' + kpgod);
    settpdata('https://api.cemon.ru/tm/?id=' + selectpisheblok);
    varn();
    
    getkpdate();
    getinn();
    getmenuinfo(selectpisheblok, selectstart, selectend);
    getlistzapros(selectpisheblok);
    getpin(selectpisheblok);
    getguid(selectpisheblok);
    setpinpinkode();
    setlistpr('https://api.cemon.ru/perezaprosmenu/proverka/?id=' + selectpisheblok + '&n=' + selectstart + '&k=' + selectend);
    getcountposech();
    getlink();
    getPollStatistics(selectpisheblok); // Эта функция теперь сама установит и pollStats, и eatingChildrenCount
    loadNews();
  }
}, [selectstart, selectend, selectpisheblok]);


//Ссылка для адреса папки food
const editlink = (va,vab)=>{
if (va=='Сайт'){
    return(
      <div><a href={vab} target='_blank'>{vab}</a></div>
    )}
    else
    {
      return(
        <div>{vab}</div>
      )}
    }


//---------Состояние опроса-----------------
const renderPollStatsWarning = () => {
  if (pollStatsLoading) {
    return (
      <div className={'content-block dx-card responsive-paddings'} style={{ marginBottom: '10px', backgroundColor: '#f5f5f5' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div className="dx-icon dx-icon-info" style={{ fontSize: '20px' }}></div>
          <div>Загрузка статистики опроса...</div>
        </div>
      </div>
    );
  }
  
  if (!pollStats) return null;
  
  const totalResponses = pollStats.statistics?.total_responses || 0;
  const parentsCount = pollStats.statistics?.parents?.count || 0;
  const childrenCount = pollStats.statistics?.children?.count || 0;
  const parentsLastResponse = pollStats.statistics?.parents?.last_response;
  const childrenLastResponse = pollStats.statistics?.children?.last_response;
  const childrenByGrade = pollStats.distribution?.children_by_grade || [];
  const foodBlock = pollStats.food_block;
  
  const hasEatingData = eatingChildrenCount !== null && eatingChildrenCount > 0;
  
  let message = '';
  let backgroundColor = '';
  let icon = '';
  let percentage = null;
  
  if (hasEatingData && eatingChildrenCount > 0) {
    percentage = ((totalResponses / eatingChildrenCount) * 100).toFixed(1);
    
    if (percentage < 10) {
      message = `НИЗКАЯ ЗАИНТЕРЕСОВАННОСТЬ (${percentage}% от ${eatingChildrenCount} питающихся детей, всего ${totalResponses} респондентов). Рекомендуется активизировать работу по привлечению родителей и детей к участию в опросе.`;
      backgroundColor = '#fff3cd';
      icon = '⚠️';
    } else if (percentage >= 10 && percentage < 15) {
      message = `СРЕДНЯЯ ЗАИНТЕРЕСОВАННОСТЬ (${percentage}% от ${eatingChildrenCount} питающихся детей, всего ${totalResponses} респондентов). Желательно увеличить количество участников опроса.`;
      backgroundColor = '#fff9e6';
      icon = 'ℹ️';
    } else if (percentage >= 15 && percentage < 20) {
      message = `ХОРОШАЯ ЗАИНТЕРЕСОВАННОСТЬ (${percentage}% от ${eatingChildrenCount} питающихся детей, всего ${totalResponses} респондентов). Работа с опросами ведётся активно`;
      backgroundColor = '#d4edda';
      icon = '📊';
    } else {
      message = `ОТЛИЧНАЯ ЗАИНТЕРЕСОВАННОСТЬ (${percentage}% от ${eatingChildrenCount} питающихся детей, всего ${totalResponses} респондентов) `;
      backgroundColor = '#c8e6c9';
      icon = '🏆';
    }
  } else {
    // Старая логика, если нет данных о питающихся
    if (totalResponses < 20) {
      message = `ОЧЕНЬ НИЗКАЯ ЗАИНТЕРЕСОВАННОСТЬ (${totalResponses} респондентов). Рекомендуется активизировать работу по привлечению родителей и детей к участию в опросе.`;
      backgroundColor = '#fff3cd';
      icon = '⚠️';
    } else if (totalResponses >= 20 && totalResponses <= 100) {
      message = `СРЕДНЯЯ ЗАИНТЕРЕСОВАННОСТЬ (${totalResponses} респондентов). Желательно увеличить количество участников опроса.`;
      backgroundColor = '#fff9e6';
      icon = 'ℹ️';
    } else {
      message = `ВЫСОКАЯ ЗАИНТЕРЕСОВАННОСТЬ (${totalResponses} респондентов). Работа с опросами ведётся активно!`;
      backgroundColor = '#d4edda';
      icon = '✅';
    }
  }
  
  // Вычисляем проценты
  const parentsPercent = totalResponses > 0 ? (parentsCount / totalResponses * 100).toFixed(1) : 0;
  const childrenPercent = totalResponses > 0 ? (childrenCount / totalResponses * 100).toFixed(1) : 0;
  
  // Находим самый активный класс
  let mostActiveGrade = null;
  if (childrenByGrade.length > 0) {
    mostActiveGrade = childrenByGrade.reduce((max, item) => 
      item.count > max.count ? item : max, childrenByGrade[0]
    );
  }
  
  const totalChildrenFromGrades = childrenByGrade.reduce((sum, item) => sum + item.count, 0);
  
  return (
    <div className={'content-block dx-card responsive-paddings'} style={{ marginBottom: '10px', backgroundColor, borderLeft: `4px solid ${hasEatingData && eatingChildrenCount > 0 
      ? (percentage < 10 ? '#ffc107' : percentage < 15 ? '#ff9800' : percentage < 20 ? '#2196f3' : '#28a745')
      : (totalResponses < 20 ? '#ffc107' : totalResponses <= 100 ? '#ff9800' : '#28a745')}` }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: '8px 0' }}>
        {/* Основная информация */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '20px' }}>{icon}</span>
          <div style={{ flex: 1 }}>
            <strong>Активность опроса апрель-май 2026</strong>
            <span style={{ marginLeft: '8px' }}>{message}</span>
            <span style={{ marginLeft: '8px' }}>
              <a 
                href="https://monitoring.cemon.ru/#/opros" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ 
                  color: '#0066cc', 
                  textDecoration: 'none',
                  borderBottom: '1px dashed #0066cc'
                }}
                onMouseEnter={(e) => e.target.style.borderBottom = '1px solid #0066cc'}
                onMouseLeave={(e) => e.target.style.borderBottom = '1px dashed #0066cc'}
              >
                Перейти к опросу →
              </a>
            </span>
          </div>
          <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#333', whiteSpace: 'nowrap' }}>
            👨‍👩‍👧 Всего: {totalResponses}
          </div>
        </div>
        
        {/* Информация о питающихся детях, если есть */}
        {hasEatingData && eatingChildrenCount > 0 && (
          <div style={{ 
            paddingLeft: '30px', 
            fontSize: '12px', 
            color: '#555',
            borderBottom: '1px solid rgba(0,0,0,0.05)',
            paddingBottom: '8px'
          }}>
            🍽️ Питающихся детей: {eatingChildrenCount} | 
            Охват опросом: {percentage}% 
            {percentage >= 20 && <span style={{marginLeft: '5px'}}>🎉</span>}
            {percentage >= 15 && percentage < 20 && <span style={{marginLeft: '5px'}}>👍</span>}
            {percentage < 10 && <span style={{marginLeft: '5px'}}>⚠️</span>}
            <span style={{ marginLeft: '8px', fontSize: '11px', color: '#666' }}>
              (респондентов {totalResponses} из {eatingChildrenCount} питающихся)
            </span>
          </div>
        )}
        
        {/* Если нет данных о питающихся, показываем предупреждение */}
        {!hasEatingData && eatingChildrenCount === null && !pollStatsLoading && (
          <div style={{ 
            paddingLeft: '30px', 
            fontSize: '11px', 
            color: '#856404',
            backgroundColor: '#fff3cd',
            padding: '5px 10px',
            borderRadius: '4px',
            marginBottom: '5px'
          }}>
            📊 (Нет данных или ошибка загрузки данных с https://sas.ficto.ru о кол-ве питающихся начальной школы) — оценка активности производится по абсолютному количеству респондентов.
            
          </div>
        )}
        
        {/* Детализация по родителям и детям с процентами */}
        <div style={{ 
          display: 'flex', 
          gap: '20px', 
          paddingLeft: '30px',
          fontSize: '12px',
          color: '#555',
          borderBottom: '1px solid rgba(0,0,0,0.05)',
          paddingBottom: '8px',
          flexWrap: 'wrap'
        }}>
          <span>Распределение по типу респондентов: 👨‍👩 Родители: {parentsCount} ({parentsPercent}%)</span>
          <span>🧒 Дети: {childrenCount} ({childrenPercent}%)</span>
          {parentsLastResponse && (
            <span>📅 Последний ответ родителей: {new Date(parentsLastResponse).toLocaleDateString('ru-RU')}</span>
          )}
          {childrenLastResponse && (
            <span>📅 Последний ответ детей: {new Date(childrenLastResponse).toLocaleDateString('ru-RU')}</span>
          )}
          <center>
            <Button
              width={300}
              text="Посмотреть результат"
              type="default"
              stylingMode="contained"
              onClick={() => clickopros()}
            />
          </center>
        </div>
        
        {/* Таблица с распределением по классам */}
        {childrenByGrade.length > 0 && (
          <div style={{ paddingLeft: '30px' }}>
            <div style={{ fontSize: '12px', marginBottom: '5px', color: '#666' }}>
              <strong>📊 Распределение ответов детей по параллелям:</strong>
              {totalChildrenFromGrades !== childrenCount && childrenCount > 0 && (
                <span style={{ fontSize: '11px', color: '#999', marginLeft: '8px' }}>
                  (учтено {totalChildrenFromGrades} из {childrenCount})
                </span>
              )}
            </div>
            <div style={{ 
              display: 'flex', 
              flexWrap: 'wrap', 
              gap: '8px',
              backgroundColor: 'rgba(255,255,255,0.6)',
              padding: '8px',
              borderRadius: '4px',
              marginBottom: '5px'
            }}>
              {childrenByGrade.map((item, index) => {
                const gradePercent = totalChildrenFromGrades > 0 ? (item.count / totalChildrenFromGrades * 100).toFixed(1) : 0;
                let gradeBgColor = '';
                if (hasEatingData && eatingChildrenCount > 0) {
                  if (percentage < 10) gradeBgColor = '#ffeaa7';
                  else if (percentage < 15) gradeBgColor = '#ffe0b3';
                  else if (percentage < 20) gradeBgColor = '#b3e5fc';
                  else gradeBgColor = '#c8e6c9';
                } else {
                  if (totalResponses < 20) gradeBgColor = '#ffeaa7';
                  else if (totalResponses <= 100) gradeBgColor = '#ffe0b3';
                  else gradeBgColor = '#c8e6c9';
                }
                return (
                  <div 
                    key={index}
                    style={{ 
                      backgroundColor: gradeBgColor,
                      padding: '4px 10px',
                      borderRadius: '15px',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}
                  >
                    {item.grade} параллель: {item.count} {item.count === 1 ? 'ученик' : item.count <= 4 ? 'ученика' : 'учеников'} ({gradePercent}%)
                  </div>
                );
              })}
            </div>
            
            {/* Самый активный класс */}
            {mostActiveGrade && mostActiveGrade.count > 0 && (
              <div style={{ 
                fontSize: '11px', 
                color: '#555',
                paddingLeft: '5px',
                marginTop: '5px'
              }}>
                🏆 Самая активная: {mostActiveGrade.grade} параллель ({mostActiveGrade.count} ответов)
              </div>
            )}
          </div>
        )}
        
        {/* Дополнительная информация о пищеблоке */}
        {foodBlock && (
          <div style={{ 
            paddingLeft: '30px', 
            fontSize: '11px', 
            color: '#888',
            borderTop: '1px solid rgba(0,0,0,0.05)',
            paddingTop: '8px',
            marginTop: '4px'
          }}>
            Источник информации по количеству питающихся — мониторинг пищеблоков на sas.ficto.ru.<br></br> В статистике не учитываются ответы на опрос, проводимый через ГосУслуги.<br></br> Данная информация носит сугубо справочный характер
          </div>
        )}
      </div>
    </div>
  );
};

//-----------Блок настройки столбцов-------------------------
    //Раздел
    const otbrrazdel = (va)=>{
      if (va==''){
          return(
            <div><b>не указан</b></div>
          )}
          else
          {
            return(
              <div>{va}</div>
            )}
          }

//------------[Проверка выхода блюда]-------------------------




          const otbrvihod = (va,vb)=>{
            const error=<div className='examplethree'>{vb}</div>;

            if (va==='гор.блюдо'&& vb<150){return (error)}
            else if (va==='2 блюдо'&& vb<90) {return (error)}
            else if (va==='1 блюдо'&& vb<200) {return (error)}
            else if (va==='гарнир'&& vb<150) {return (error)}
            else if (va==='закуска'&& vb<60) {return (error)}
            else if (va==='фрукты'&& vb<100) {return (error)}
            else {return (<div>{vb}</div>)}
          }

//---------------[Не разбиты ли приёмы пищи на отдельные строчки]------------
const proverkavihoda = ()=>{

}


const linkCell = (cellData: DataGridTypes.ColumnCellTemplateData) => (
  

 <div>{editlink(cellData.data.Показатель,cellData.data.Значение)}</div>)



const VihodCell = (cellData: DataGridTypes.ColumnCellTemplateData) => ( 
    <div>
    
    {otbrvihod(cellData.data.Раздел, cellData.data.Выход)}
    </div>
)

const ChartRazdel = (cellData: DataGridTypes.ColumnCellTemplateData) => ( 
  <div>
  
  {otbrrazdel(cellData.data.Раздел)}
  </div>
)

const bludoCell = (cellData: DataGridTypes.ColumnCellTemplateData) => ( 
  <div>
  
  {otbrrazdel(cellData.data.Блюдо)}
  </div>
)


//Замена запятых
const pattern = /,/g;

//Функция экспорта
const onExporting = (e: DataGridTypes.ExportingEvent) => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Выгрузка');

  exportDataGrid({
    component: e.component,
    worksheet,
    autoFilterEnabled: true,
  }).then(() => {
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Экспорт.xlsx');
    });
  });
};


const clickmenu = (values)=>{
  setmenutitle(values.data['Дата']);
  setmenuVisible(true);
  const toDate = (dateStr) => {
    const [day, month, year] = dateStr.split(".")
    return new Date(year, month - 1, day)
  }
  const momentObj=toDate(values.data['Дата']);
  setmenudataw('https://api.cemon.ru/menudata/menuzadatu?id='+selectpisheblok+'&n='+Moment(momentObj).format("YYYY,MM,DD"));
  
}

const handlePopupHidden = useCallback(() => {
  setmenuVisible(false);
  setmenudataw();
}, [menuVisible]);


  const  editlinkitog =() => {

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 'guid': guidzapros, 'link': newlink, 'pin': pinpinkode})
    };
    fetch('https://api.cemon.ru/editlink/', requestOptions)
        .then(response => response.json())
        .then(data => setresulteditlink(data.result));
  }




const rendermenuwin = useCallback(() => {
  return(
  <div style={{height:'80%'}}>
  <DataGrid
    dataSource={menudataw}
    showBorders={true}
    width='100%'
    allowColumnResizing={true}
    style={{ paddingTop: 0, paddingBottom: 0}}
    showColumnLines={true}
    wordWrapEnabled={true}

   
  >
    <LoadPanel
        height={100}
        width={200}
        indicatorSrc={require('./load.gif')}

    />
  </DataGrid>
  <Paging defaultPageSize={100} />
  
  
  
  
  </div>
  )
}, [menudataw]);



  const rendermenuwilinkedit = useCallback(() => {



    return(
        <div></div>

    )
  }, []);





  const handlePopupHiddensab = useCallback(() => {
    setmenuVisiblesab(false);
  }, []);

  const clickmenusab = (values) => {
    setmenutitlesab(values.data['Дата']);
    setmenuVisiblesab(true);
    const toDate = (dateStr) => {
      const [day, month, year] = dateStr.split(".")
      return new Date(year, month - 1, day)
    }
    const momentObj = toDate(values.data['Дата']);
    setmenudatawsab('https://api.cemon.ru/sopostovlenie/sab?n=' + values.data['СсылкаНаТМСсылка']+'&k='+values.data['НомерДняВМеню']);
  setmenudatawsabb('https://api.cemon.ru/menudata/menuzadatu?id='+selectpisheblok+'&n='+Moment(momentObj).format("YYYY,MM,DD"));
  setmenudatawsabbb(values.data['Замечания']);

}

// Функция открытия результатов опроса
const clickopros = () => {
  setShowPollResults(true);
}

// Функция закрытия результатов опроса
const handleClosePollResults = useCallback(() => {
  setShowPollResults(false);
}, []);


const rendermenuwinsab = useCallback(() => {
  return(
<div>

<div className="tables">
    <div className="column">
    <div className={'title-table'}><b>ТИПОВОЕ МЕНЮ</b></div>
    <DataGrid
    dataSource={menudatawsab}
    showBorders={true}
    width='100%'
    allowColumnResizing={true}
    style={{ paddingTop: 0, paddingBottom: 0}}
    columnAutoWidth={true}
    columnHidingEnabled={true}
    showColumnLines={true}
    //dataRowRender={DataRow}
    hoverStateEnabled={true}
    onExporting={onExporting}
    wordWrapEnabled={true}
    
   
  >

    <ColumnChooser enabled={true} mode="select" />
  <Export enabled={true} />
  <Paging defaultPageSize={15} />
  <Pager showPageSizeSelector={false} showInfo={true} />
      <GroupPanel visible={false} />
      <LoadPanel
          height={100}
          width={200}
          indicatorSrc={require('./load.gif')}
      />



  </DataGrid>
  
    </div>
    <div className="column">
    <div className={'title-table'}><b>ФАКТИЧЕСКОЕ МЕНЮ</b></div>
    <DataGrid
    dataSource={menudatawsabb}
    showBorders={true}
    width='100%'
    allowColumnResizing={true}
    style={{ paddingTop: 0, paddingBottom: 0}}
    columnAutoWidth={true}
    columnHidingEnabled={true}
    showColumnLines={true}
    //dataRowRender={DataRow}
    hoverStateEnabled={true}
    onExporting={onExporting}
    wordWrapEnabled={true}
    
   
  >
    <Column dataField="ПриемПищиНаименование"/>
    <Column dataField="Раздел" />
    <Column dataField="Блюдо" />
    <Column dataField="Выход" />
    <ColumnChooser enabled={true} mode="select" />
  <Export enabled={true} />
  <Paging defaultPageSize={15} />
  <Pager showPageSizeSelector={false} showInfo={true} />
      <LoadPanel
          height={100}
          width={200}
          indicatorSrc={require('./load.gif')}

      />
  </DataGrid>
      
    </div>
    
    </div>
    <div className={'dx-card block'}>
    {menudatawsabbb}
    </div>
  </div>
  )
}, [menudatawsab,menudatawsabb]);

const pickerRef = useRef()



const renderTitle = () => {
  return (
    <div>
      <div className={'title-table'} style={{height:'40px'}}>МЕНЮ ПИЩЕБЛОКА ЗА {menutitle}</div>
      <Button icon="close" className={'dx-icon-closes'} onClick={handlePopupHidden}/>
      </div>
  );
}
//-----------------Дополнительная информация о пищеблоке---------------------
const [menuinfoVisible, setmenuinfoVisible] = useState(false);
const [dadatainfo, setdadatainfo] = useState([]);
const [link, setlink] = useState([]);


function getinn() {
  return fetch('https://api.cemon.ru/inn/?id='+selectpisheblok)
  .then((response) => response.json())
  .then((responseJson) => {
  setinn( responseJson[0].ИНН);
  })
  .catch((error) => {
    
  });
}

  function getlink() {
    return fetch('https://api.cemon.ru/pishinfo/?id='+selectpisheblok)
        .then((response) => response.json())
        .then((responseJson) => {
          setlink( responseJson[4].Значение);
        })
        .catch((error) => {

        });
  }



  function getkpdate() {
    return fetch('https://api.cemon.ru/kp/date.php?id='+selectpisheblok+'&g='+kpgod)
        .then((response) => response.json())
        .then((responseJson) => {
          setkpdate( responseJson[0].Дата);
        })
        .catch((error) => {

        });
  }



  function getcountposech() {
    return fetch('https://api.cemon.ru/logs/analizstat/?id='+selectpisheblok)
        .then((response) => response.json())
        .then((responseJson) => {
          setkpos( responseJson[0].k);
        })
        .catch((error) => {

        });
  }





function Mappokaz(){
  if (coordina){
        return  (
                  <div>
          <YMaps>
                  <Map width='100%' defaultState={{center: coordina,zoom: 15, controls: ["zoomControl", "fullscreenControl"],}} modules={["control.ZoomControl", "control.FullscreenControl"]} >
                  <Placemark defaultGeometry={coordina} />
                  </Map>
          </YMaps>
</div>

  )} else {

return (<div>Нет</div>)
  }
}

const clickmenuinfo = () => {
  setmenuinfoVisible(true);
  getdadaApi();

   }

   const handlePopupHiddeninfo = () => {
    setmenuinfoVisible(false);
  }

  //---------Вывод модального окна по основной информации-------------
  
  
  

  function getdadaApi() {
    fetch('https://api.cemon.ru/dadata?inn='+inn)
      .then((response) => response.json())
      .then((responseJson) => {
      setdadatainfo(responseJson);
    const a = [];
    a[0] = responseJson[9].Значение;
    a[1] = responseJson[10].Значение
    setcoordina(a);
    })
    .catch((error) => {});

  }
  
  

    



  const rendermenuwininfo =() => {
    return(
    <div> 
    <DataGrid
    ref={pickerRef}
    dataSource={dadatainfo}
    showBorders={true}
    width='100%'
    allowColumnResizing={true}
    style={{ paddingTop: 0, paddingBottom: 0}}
    showColumnLines={true}
    wordWrapEnabled={true}
  >
      <LoadPanel
          height={100}
          width={200}
          indicatorSrc={require('./load.gif')}

      />
    </DataGrid>
 
 
<div>
<Mappokaz />
</div>
    </div>  
  )
  }

//----------------------Проверка меню (Общая)---------------------

      //-------------------Проверка выхода-------------------
            const provervihoda = (priem, vihod)=>{
              const error=<div className='examplethree'>{vihod}</div>;
              if (priem==='Завтрак'&& vihod<500){return (error)}
              else if (priem==='Обед'&& vihod<700) {return (error)}
              else if (priem==='Завтрак 2'&& vihod<200) {return (error)}
              else if (priem==='Полдник'&& vihod<300) {return (error)}
              else if (priem==='Ужин'&& vihod<500) {return (error)}
              else if (priem==='Ужин 2'&& vihod<200) {return (error)}
              else {return (<div>{vihod}</div>)}
            }

            //------------------Проверка цены---------------------------
            const provercena = (cen)=>{
              const error=<div className='examplethree'>{cen}</div>;
              if (cen<1){return (error)}
              else {return (<div>{cen}</div>)}
            }


            //-------------------Проверка калорийности-------------------
            const proverkalor = (priem, kalor)=>{

              const error=<div className='examplethree'>{kalor}</div>;
              if (priem==='Завтрак'&& kalor<470){return (error)}
              else if (priem==='Обед'&& kalor<670) {return (error)}

              else {return (<div>{kalor}</div>)}
            }

//--------------Вывод ячеек-------------------------------------------------------

          //------------Выход-------------
          const Obshvihod = (cellData: DataGridTypes.ColumnCellTemplateData) => ( 
            <div>{provervihoda(cellData.data.ПриемПищиНаименование,cellData.data.Выход)}</div>
          )
          //------------Кол-во Ошибок-------------------
          const Cena=(cellData: DataGridTypes.ColumnCellTemplateData) => ( 
            <div>{provercena(cellData.data.Цена)}</div>
            )

          //------------Калорийность------------
          const Calorinost = (cellData: DataGridTypes.ColumnCellTemplateData) => ( 
            <div>{proverkalor(cellData.data.ПриемПищиНаименование,cellData.data.Калорийность)}</div>
          )

          //------------Кол-во Ошибок-------------------
          const Oshibki=(cellData: DataGridTypes.ColumnCellTemplateData) => ( 
          <div className='examplethree'>{cellData.data.ЧислоОшибок}</div>
          )


          const lanerror =(e:DataErrorOccurredEvent)=>{
              e.error.message="Ошибка загрузки данных";
      }

//----------------Вывод динамики размещения меню ------------------------

//----Дата---------------------------------------------------------------
const formatDate = new Intl.DateTimeFormat('ru').format;
const dinamikdate=(cellData: DataGridTypes.ColumnCellTemplateData) => {
  if (cellData.data.ПищеблокФункционировал === "да"){
    
  return(
  <div className='vihodnoi'>{formatDate(new Date(cellData.data.Дата))+' (выходной по КП*)'}</div>
  )
}
else {
  return(
    <div>{formatDate(new Date(cellData.data.Дата))+' ('+cellData.data.НомерДняВМеню+')'}</div> 
  )
}
}

//----Файл скачан---------------------------------------------------------------

const dinamikfile=(cellData: DataGridTypes.ColumnCellTemplateData) => {
  if ((cellData.data.ПищеблокФункционировал === "")&&(cellData.data.Файл === "да")) {return(<div>{cellData.data.Файл}</div>)}
  else if ((cellData.data.ПищеблокФункционировал === "да")&&(cellData.data.Файл === "да") ){return(<abbr title="Выгрузка в нерабочий день пищеблока. Проверьте календарь питания"><div className='examplethree'>{cellData.data.Файл}</div></abbr>)}
  else if ((cellData.data.ПищеблокФункционировал === "")&&(cellData.data.Файл === "нет") ){return(<div className='examplethree'>{cellData.data.Файл}</div>)}
  else if ((cellData.data.ПищеблокФункционировал === "да")&&(cellData.data.Файл === "нет")) {return(<div className='vihodnoi'>{cellData.data.Файл}</div>)}
                                                                      }
//----Обработан---------------------------------------------------------------
const dinamikobr=(cellData: DataGridTypes.ColumnCellTemplateData) => {
  if ((cellData.data.ПищеблокФункционировал === "")&&(cellData.data.Меню === "да")) {return(<div>{cellData.data.Меню}</div>)}
  else if ((cellData.data.ПищеблокФункционировал === "да")&&(cellData.data.Меню === "да") ){return(<abbr title="Выгрузка в нерабочий день пищеблока. Проверьте календарь питания"><div className='examplethree'>{cellData.data.Меню}</div></abbr>)}
  else if ((cellData.data.ПищеблокФункционировал === "")&&(cellData.data.Меню === "нет") ){return(<abbr title="Меню не обработано системой"><div className='examplethree'>{cellData.data.Меню}</div></abbr>)}
  else if ((cellData.data.ПищеблокФункционировал === "да")&&(cellData.data.Меню === "нет")) {return(<div className='vihodnoi'>{cellData.data.Меню}</div>)}
                                                                        }
//----Вовремя---------------------------------------------------------------
const dinamiksvoe=(cellData: DataGridTypes.ColumnCellTemplateData) => {
  if ((cellData.data.ПищеблокФункционировал === "")&&(cellData.data.Своевременность === "да")) {return(<div>{cellData.data.Своевременность}</div>)}
  else if ((cellData.data.ПищеблокФункционировал === "да")&&(cellData.data.Своевременность === "да") ){return(<abbr title="Выгрузка в нерабочий день пищеблока. Проверьте календарь питания"><div className='examplethree'>{cellData.data.Своевременность}</div></abbr>)}
  else if ((cellData.data.ПищеблокФункционировал === "")&&(cellData.data.Своевременность === "нет") ){return(<abbr title="Файл обработан более чем через 9 часов после начала дня"><div className='examplethree'>{cellData.data.Своевременность}</div></abbr>)}
  else if ((cellData.data.ПищеблокФункционировал === "да")&&(cellData.data.Своевременность === "нет")) {return(<div className='vihodnoi'>{cellData.data.Своевременность}</div>)}
                                                                        }

//----Ошибок в меню---------------------------------------------------------------
const dinamikoshib=(cellData: DataGridTypes.ColumnCellTemplateData) => {
  if (cellData.data.ЧислоОшибок > 0) {return(<div className='examplethree'>{cellData.data.ЧислоОшибок}</div>)}
  else {return(<div>{cellData.data.ЧислоОшибок}</div>)}
}
//----% Соблюдения---------------------------------------------------------------
const dinamiksoblud=(cellData: DataGridTypes.ColumnCellTemplateData) => {
  if ((cellData.data.ПроцентСоблюдения < 90)&&(cellData.data.ПроцентСоблюдения !== "")) {return(<abbr title="Низкий % соблюдения типового меню. Подробная информация в таблице СОБЛЮДЕНИЕ ТИПОВОГО МЕНЮ"><div className='examplethree'>{cellData.data.ПроцентСоблюдения+'%'}</div></abbr>)}
  else if (cellData.data.ПроцентСоблюдения === "") {return(<div>{cellData.data.ПроцентСоблюдения}</div>)}
  else {return(<div>{cellData.data.ПроцентСоблюдения+'%'}</div>)}
}

const Dinamikinfo = useCallback(() =>{
  return(
    <div>
         
<DataGrid
    dataSource={menuinfo}
    showBorders={true}
    width='100%'
    allowColumnResizing={true}
    showColumnLines={true}
    wordWrapEnabled={true}
    //hoverStateEnabled={true}
    //hoverStateEnabled={true}
    onDataErrorOccurred={lanerror}
    columnHidingEnabled={false}
    onExporting={onExporting}
  >
  
  <Column dataField="Дата" caption="Дата и номер дня в КП* и ТМ**" dataType="date" defaultSortOrder="desc" minWidth={60} fixed={true} cellRender={dinamikdate} />
  
    <Column dataField="Файл" caption="Файл скачан" minWidth={50} cellRender={dinamikfile}/>
    <Column dataField="Меню" caption="Файл обработан" minWidth={50} cellRender={dinamikobr}/>
    <Column dataField="Своевременность" caption="Соблюдение сроков***" minWidth={50} cellRender={dinamiksvoe}/>
    <Column dataField="ЧислоОшибок" caption="Кол-во ошибок по СанПин" cellRender={dinamikoshib} minWidth={50}/>
    <Column dataField="ПроцентСоблюдения" caption="% соблюдения ТМ" cellRender={dinamiksoblud} minWidth={50}/>
    
    <Export enabled={true} />
  <LoadPanel
      height={100}
      width={200}
      indicatorSrc={require('./load.gif')}

  />
    </DataGrid>
    <div>*КП - календарь питания. Файл с имененем kpXXXX.xlsx, где XXXX - год (Например kp2026.xlsx). Располагается в папке food образовательной организации. <b>При отсутствии КП все дни считаются выходными.</b></div>
    <div>**ТМ - типовое меню. Файл с именем tmXXXX-sm.xlsx, где XXXX - год (Например tm2026-sm.xlsx). Располагается в папке food образовательной организации</div>
    <div>**Соблюдение сроков - Файл считан и обработан до 9:00 дня питания</div>
    
              
</div>
  )
},[menuinfo])


//---------------Модальное окно заявки на дочтение меню------------------------НАЧАЛО
 const openwinzapros =()=>{
   setmodzaprosvid(true);
   getlistzapros(selectpisheblok);

 }

  const otpraveditlink =()=>{


  if(newlink==null){return;}
    if((newlink.slice(0,7) == "http://") || (newlink.slice(0,8) == "https://")){

    }
    else{setresulteditlink('ОШИБКА: Ссылка должна начинаться с http:// или https://');return;}

    if((newlink.substr(newlink.length - 5) == "/food") || (newlink.substr(newlink.length - 6) == "/food/")){

    }
    else{setresulteditlink('ОШИБКА: Ссылка должна заканчиваться на /food');	return;	}

    editlinkitog();
  }




  const openwinlinkedit =()=>{
    setmodlinkedit(true);
    //getlistzapros(selectpisheblok);

  }

  const openwinhelp = useCallback(() => {
    setwinprob(true);
  }, []);


  const hidewineditlink = useCallback(() => {
    setmodlinkedit(false);
  }, []);


const hideInfoModalWindowsMenu = useCallback(() => {
  setmodzaprosvid(false);
}, []);

  const handlewinprob = useCallback(() => {
    setwinprob(false);
  }, []);



const [modzaprosvid, setmodzaprosvid] = useState(false)
const [listzapros, setlistzapros] = useState(false)
  const [modlinkedit, setmodlinkedit] = useState(false)


  function getlistzapros(id) {
    return fetch("https://api.cemon.ru/perezaprosmenu/list/?id="+id)
        .then((response) => response.json())
        .then((responseJson) => {
          setlistzapros(responseJson)
        })
        .catch((error) => {

        });
  }

  function getmenuinfo(selectpisheblok,selectstart,selectend) {
    return fetch('https://api.cemon.ru/menustat?id='+selectpisheblok+'&n='+selectstart+'&k='+selectend)
        .then((response) => response.json())
        .then((responseJson) => {
          setmenuinfo(responseJson)
        })
        .catch((error) => {

        });
  }




  const [pinzapros, setpinzapros] = useState(false)
  const [keyref, setkeyref] = useState(false)

  const getpin = async (id) => {
    const response = await fetch(
        "https://api.cemon.ru/pinchange/?id="+id
    ).then((response) => response.json());
    setpinzapros(response.pin);

  };




  const [guidzapros, setguidzapros] = useState(false)

  function getguid(id) {
    return fetch("https://api.cemon.ru/perezaprosmenu/guid/?id="+id)
        .then((response) => response.json())
        .then((responseJson) => {
          setguidzapros(responseJson[0].Ref_Key)
        })
        .catch((error) => {

        });
  }




  const [rezultperezapros, setrezultperezapros] = useState('Отправка запроса...')
  const [resultperezaprosvisible, setresultperezaprosvisible] = useState(false);
  const [winprob, setwinprob] = useState(false);


  const hideInfoperezapros = useCallback(() => {
    getlistzapros(selectpisheblok);
    setresultperezaprosvisible(false);
  }, [selectpisheblok]);

  function setperezapros(id,n,k,pin) {
    return fetch("https://api.cemon.ru/perezaprosmenu?id="+id+"&dates="+n+"&datepo="+k+"&pin="+pin)
        .then((response) => response.json())
        .then((responseJson) => {
          setrezultperezapros(responseJson);
        })
        .catch((error) => {

        });
  }



//Вывод поле с вводом пинкода
  const Pincode = useCallback(() =>{
    if (pinzapros===1){
    return(
        <center><div>Внимание, у данного пищеблока установлен пин код. Введите его :
        <div style={{width: '100px', display: 'inline-block', margin: '5px'}}>
          <TextBox

              defaultValue=''
              placeholder='Пин код'
              onValueChanged={valuechangepin}
              //value={pinpinkode}
              valueChangeEvent='change'
          /></div>
          Если Вы не знаете пин код, обратитесь к региональному отвественному за питание


        </div></center>
          )}},[pinzapros])

  const otpravdata = () => {
    setrezultperezapros('Отправка запроса');
    setperezapros(guidzapros,selectstart,selectend,pinpinkode);
    setresultperezaprosvisible(true);
  }

  const [pinpinkode, setpinpinkode] = useState();

  const [listpr, setlistpr] = useState();


  const valuechangepin = useCallback(({ value }) => {
    setpinpinkode(value);
  }, []);

  function ValidURL(str) {
    var regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
    if(!regex .test(str)) {
      return false;
    } else {
      return true;
    }
  }


  const perehod = useCallback(({ value, rowIndex }) => {
    if (ValidURL(value)){window.open(value, '_blank').focus();};

  }, []);


//---------------Модальное окно заявки на дочтение меню------------------------КОНЕЦ

  function statuskp() {

    if(kpdate.length>3){
    return (
        <fr>файл kp{kpgod}.xlsx обработан {kpdate}</fr>
    );
    }
    else{

      return (
          <fr>файл kp{kpgod}.xlsx отсутвует или не обработан</fr>
      );

    }
  }

  function varn() {

    if(kpdate.length>3 ){

    }
    else{
if(selectpisheblok>1){
      return (
          <fr>
            <center><b><font color='red'>ДАННЫЙ ПИЩЕБЛОК НЕ ФУНКЦИОНИРУЕТ ИЛИ НЕ ЗАГРУЖЕН КАЛЕНДАРЬ
              ПИТАНИЯ</font></b><br/>
              <p onClick={openwinhelp} className={'pointlink'}>Как решить проблему?</p>

            </center>
          </fr>
      );
}

    }
  }


//------------------------------------------------------------------------------------------------------------------------------------------------------------
  

  //---------------- Блок основного вывода --------------------------------------------------------------------------------------------------------------------
  if (!status){

    return (
        <div className={'content-block dx-data-row2'}>
          <center><font size={15}>Сервер недоступен...</font></center>
        </div>
  )
  }
  else {
  return (
      <div>

        <div className={'content-block dx-data-row2'}>

        </div>


        <div className={'content-block dx-data-row2'}>
  <h2>Анализ ежедневного меню пищеблока <i>{selectpisheblok}</i></h2>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '20px', flexWrap: 'wrap' }}>
    <div>
      <TextBox
        style={{ width: '200px', display: 'inline-block', marginRight: '10px' }}
        defaultValue=""
        placeholder="Поиск по коду"
        onValueChanged={valueChangedidpoisk}
        valueChangeEvent="change"
      />
      <Button
        width={100}
        text="Найти"
        type="default"
        stylingMode="contained"
        onClick={() => PoiskPoid()}
        icon="search"
      />
      <button id="link1" text="?" style={{ verticalAlign: 'top', fontSize: '8px' }}>?</button>
    </div>
    <div style={{ flex: '1', minWidth: '250px', maxWidth: '400px' }}>
      {renderNewsBlock()}
    </div>
  </div>
</div>

        <div className={'content-block dx-card responsive-paddings'} style={{overflow: 'visible'}}>

          <div className={'title-table'}><b>ВЫБОР ПИЩЕБЛОКА</b></div>

          <div style={{width: '100%'}}>

            <Lookup
                id="Region"
                label="Регион"
                labelMode='static'
                stylingMode='outlined'
                dataSource={listregion}
                displayExpr="label"
                valueExpr="value"
                searchEnabled={true}
                placeholder="Выбор региона"
                onValueChanged={ChangeRegion}
                value={selectregion}
                //selectedItem={selectregion}
                onDataErrorOccurred={lanerror}
            />
            <Lookup
                id="Pisheblok"
                label="Пищеблок"
                labelMode='static'
                stylingMode='outlined'
                dataSource={groupedData}
                displayExpr="label"
                valueExpr="value"
                searchEnabled={true}
                placeholder="Выбор пищеблока"
                onValueChanged={ChangePisheblok}
                value={selectpisheblok}
                //selectedItem={selectpisheblok}
                grouped={true}
                onDataErrorOccurred={lanerror}

            />


          </div>

          <Popover
              target="#link1"
              showEvent="mouseenter"
              hideEvent="mouseleave"
              position="top"
              width={300}
              showTitle={true}
              title="Код пищеблока"
          >
            Целое число для обозначения пищеблока. У каждого блока индивидуальный. Узнать код можно на странице анализа
            меню пищеблока. Необходим для быстрого поиска пищеблока и обращения в техническую поддержку. Пример кода:
            "12311"
          </Popover>

          <Popup
              visible={popupVisible}
              onHiding={hideInfo}
              dragEnabled={false}
              hideOnOutsideClick={true}
              showCloseButton={true}
              showTitle={true}
              title="Ошибка"
              container=".dx-viewport"
              width={300}
              height={280}>

            <div style={{margin: '10px'}}>
              <h4>
                <center>Пищеблок c кодом {iddlapoiska} не найден</center>
              </h4>
            </div>
          </Popup>


          <div>
            <Popup
                width={'80%'}
                height={'80%'}
                showTitle={true}
                title="Решение проблемы: 'ДАННЫЙ ПИЩЕБЛОК НЕ ФУНКЦИОНИРУЕТ ИЛИ НЕ ЗАГРУЖЕН КАЛЕНДАРЬ ПИТАНИЯ'"
                //titleRender={renderTitle}
                dragEnabled={true}
                hideOnOutsideClick={true}
                visible={winprob}
                onHiding={handlewinprob}
                showCloseButton={true}
            >
              <div>Данное сообщение означает, что в папке food образовательной организации не загружен календарь питания
                на {kpgod} год (или он еще не обработан федеральной базой). Файл должен быть доступен по адресу: <a href={link + '/kp' + kpgod + '.xlsx'}
                                                                     target={'_blank'}>{link}/kp{kpgod}.xlsx</a>
                <br/> Для устранения проблемы необходимо:
                <p>
                Проверить доступность файла по ссылке <a href={link + '/kp' + kpgod + '.xlsx'}
                                                         target={'_blank'}>{link}/kp{kpgod}.xlsx</a>. Если файл
                недоступен, загрузить его в папку food пищеблока. При наличии доступа, необходимо убедиться, что файл
                соответствует установленному шаблону: строки не удалены и не добавлены, структура файла не нарушена. Важно также проверить корректность заполнения в соответствии с <a href={'https://monitoring.cemon.ru/#/help'} target={'_blank'}>инструкцией</a>, проверить корректность заполнения поля "ГОД"

                Если проблема сохранилась и файл был загружен сегодня, дождаться 07:00 (по МСК) следующего дня. В случае, если все вышеперечисленные условия соблюдены, но файл все равно не отображается, следует обратиться в <a href={'https://t.me/+4zdUFO4mbDAxNjli'} target={'_blank'}>техническую поддержку</a> для устранения возможных неполадок.
                </p>



              </div>
            </Popup>

          </div>


          <Popup
              visible={resultperezaprosvisible}
              onHiding={hideInfoperezapros}
              dragEnabled={true}
              hideOnOutsideClick={false}
              showCloseButton={true}
              showTitle={true}
              title="Результат запроса"
              container=".dx-viewport"
              width={300}
              height={280}>

            <div style={{margin: '10px'}}>

              <center>{rezultperezapros}</center>

            </div>
          </Popup>


        </div>
        <div className="right-side">
          <SelectBox
              items={getgod}
              width={128}
              label="учебный год"
              labelMode='static'
              stylingMode='underlined'
              value={god}
              displayExpr="label"
              valueExpr="value"
              onValueChanged={setinggod}

          />
        </div>
        <div className={'content-block dx-card responsive-paddings'} style={{overflow: 'visible', height: '300px'}}>
  <div className={'title-table'}><b>ПЕРИОД ОТЧЕТА</b></div>
  
  <div style={{margin: '5px auto', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '20px'}}>
    <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
      <span>ПЕРИОД:</span>
      <DateBox
        onValueChanged={selectPeriodn}
        value={range[0]}
        labelMode='static'
        width={120}
        stylingMode='underlined'
        type="date"
        displayFormat="dd.MM.yyyy"
      />
    </div>
    
    <div style={{margin: '0 5px'}}>-</div>
    
    <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
      <DateBox
        onValueChanged={selectPeriodk}
        value={range[1]}
        labelMode='static'
        width={120}
        stylingMode='underlined'
        type="date"
        displayFormat="dd.MM.yyyy"
      />
    </div>
  </div>
  
  <div>
    <RangeSelector
      id="range-selector"
      onValueChanged={selectPeriod}
      value={range}
      // Добавляем начальные значения, чтобы избежать ошибок при первом рендере
      defaultValue={[defaultStartDate, defaultEndDate]}
    >
      <Margin top={3}/>
      <Scale
        // Используем безопасные значения
        startValue={startValue || defaultStartDate}
        endValue={endValue || defaultEndDate}
        tickInterval="day"
      />
      <SliderMarker format="monthAndDay"/>
    </RangeSelector>
  </div>
</div>
{renderPollStatsWarning()}

        <div className={'content-block dx-card responsive-paddings'} style={{overflow: 'visible'}}>
          <div className={'title-table'}><b>ОСНОВНАЯ ИНФОРМАЦИЯ</b></div>

          <div className={'zayavka'}>
            <Button
                //width={100}
                text="Изменить ссылку пищеблока"
                type="success"
                stylingMode="outlined"
                onClick={openwinlinkedit}
                icon="edit"
            /></div>
          {varn()}
          <DataGrid
              dataSource={linkdata}
              showBorders={true}
              width='100%'
              allowColumnResizing={true}
              style={{paddingTop: 0, paddingBottom: 0}}
              showColumnLines={true}
              wordWrapEnabled={true}
              // onRowClick={clickmenuinfo}
              hoverStateEnabled={true}
              onDataErrorOccurred={lanerror}
              onCellClick={perehod}
          >
            <Column dataField="Показатель" width={130} height='100px'/>
            <Column dataField="Значение"/>
            <LoadPanel
                height={100}
                width={200}
                indicatorSrc={require('./load.gif')}

            />
          </DataGrid>

          <p onClick={clickmenuinfo} className={'pointlink'}>Подробнее</p>
          <div className={'blockidsch'}>Количество просмотров данных по пищеблоку за последний месяц: {kpos}</div>

          <Popup
              width={'90%'}
              height={'95%'}
              dragEnabled={true}
              hideOnOutsideClick={false}
              visible={menuinfoVisible}
              onHiding={handlePopupHiddeninfo}
              contentRender={rendermenuwininfo}
              showCloseButton={true}
              resizeEnabled={true}

          />


        </div>



        <div className={'content-block dx-card responsive-paddings'} style={{overflow: 'visible'}}>
          <div className={'title-table'}><b>ДИНАМИКА РАЗМЕЩЕНИЯ МЕНЮ</b></div>


          <div className={'zayavka'}>
            <Button
                //width={100}
                text="Дочитать меню"
                type="success"
                stylingMode="outlined"
                onClick={openwinzapros}
                icon="xlsxfile"
            /></div>
          {varn()}
          <div className={'blockid'}>Код пищеблока: {selectpisheblok}</div>
          <Dinamikinfo/>


        </div>


        <div className={'content-block dx-card'}>
          <div className={'title-table'}><b>МЕНЮ ПИЩЕБЛОКА</b></div>
          {varn()}
          <div className={'blockid'}>Код пищеблока: {selectpisheblok}</div>
          <DataGrid
    dataSource={menudata}
    showBorders={true}
    width='100%'
    allowColumnResizing={true}
    columnAutoWidth={false}           
    columnHidingEnabled={false}       
    showColumnLines={true}
    hoverStateEnabled={false}
    onExporting={onExporting}
    onRowClick={clickmenu}
    onDataErrorOccurred={lanerror}
    scrolling={{ mode: 'standard' }}   
    height="auto"                      
>

            <Column dataField="Дата"/>
            <Column dataField="ПриемПищиНаименование" caption="Приём пищи"/>
            <Column dataField="Выход" cellRender={Obshvihod} />
            <Column dataField="Цена" cellRender={Cena} />
            <Column dataField="Калорийность" cellRender={Calorinost} />
            <Column dataField="Белки" />
            <Column dataField="Жиры" />
            <Column dataField="Углеводы" />
            <Column dataField="ЧислоОшибок" caption="Ошибок" cellRender={Oshibki}/>
            
            <Export enabled={true}/>
            <Paging defaultPageSize={10}/>
            <Pager showPageSizeSelector={false} showInfo={true}/>
            <LoadPanel
                height={100}
                width={200}
                indicatorSrc={require('./load.gif')}

            />
          </DataGrid>

        </div>

<div className={'content-block dx-card responsive-paddings'}>
  <div className={'title-table'}><b>СБАЛАНСИРОВАННОСТЬ МЕНЮ</b></div>
  {varn()}
  <div className={'blockid'}>Код пищеблока: {selectpisheblok}</div>
  <DataGrid
    dataSource={bzudata}
    showBorders={true}
    width='100%'
    allowColumnResizing={true}
    columnAutoWidth={true}
    columnHidingEnabled={true}
    showColumnLines={true}
    hoverStateEnabled={true}
    onExporting={onExporting}
    onDataErrorOccurred={lanerror}
  >
    <Column 
      dataField="ПриемПищи" 
      caption="Приём пищи" 
      width={120}
      fixed={true}
    />
    <Column 
      dataField="БелкиСрЗнач" 
      caption="Белки" 
      cellRender={({ data }) => renderNutrientCell(data.БелкиСрЗнач)}
    />
    <Column 
      dataField="ЖирыСрЗнач" 
      caption="Жиры" 
      cellRender={({ data }) => renderNutrientCell(data.ЖирыСрЗнач)}
    />
    <Column 
      dataField="УглеводыСрЗнач" 
      caption="Углеводы" 
      cellRender={({ data }) => renderNutrientCell(data.УглеводыСрЗнач)}
    />
    <Column 
      dataField="Баланс БЖУ" 
      caption="Соотношение Б:Ж:У" 
      cellRender={({ data }) => (
        <div style={{ 
          color: data['Баланс БЖУ'] === '1:1:4' ? 'green' : '#d9534f',
          fontWeight: 'bold'
        }}>
          {data['Баланс БЖУ'] || '-'}
          {data['Баланс БЖУ'] && data['Баланс БЖУ'] !== '1:1:4' && (
            <span style={{fontSize: '0.8em', color: '#666', marginLeft: '5px'}}>
              (рекомендуется 1:1:4)
            </span>
          )}
        </div>
      )}
    />
    <Export enabled={true}/>
    <Paging defaultPageSize={10}/>
    <Pager showPageSizeSelector={false} showInfo={true}/>
    <LoadPanel
      height={100}
      width={200}
      indicatorSrc={require('./load.gif')}
    />
  </DataGrid>
</div>

        <div className={'content-block dx-card responsive-paddings'} style={{overflow: 'visible'}}>
          <div className={'title-table'}><b>КАЛЕНДАРЬ ПИТАНИЯ ({statuskp()})</b>
          </div>

          <div style={{opacity: '.3'}}>Код пищеблока: {selectpisheblok}</div>

          <DataGrid
              dataSource={kplink}
              showBorders={true}
              width='100%'
              onDataErrorOccurred={lanerror}
              style={{paddingTop: 0, paddingBottom: 0}}
              columnAutoWidth={true}
              columnHidingEnabled={false}
              showColumnLines={true}
              onExporting={onExporting}
              focusedRowEnabled={false}

          >
            <Sorting mode="none" />


            <Paging pageSize={12}/>
            <Export enabled={false}/>
            <LoadPanel
                height={100}
                width={200}
                indicatorSrc={require('./load.gif')}

            />
          </DataGrid>


        </div>

        <div className={'content-block dx-card responsive-paddings'} style={{overflow: 'visible'}}>
          <div className={'title-table'}><b>ТИПОВЫЕ МЕНЮ</b>
          </div>
          <div className={'blockid'}>Код пищеблока: {selectpisheblok}</div>
          <DataGrid
              dataSource={tpdata}
              showBorders={true}
              width='100%'
              onDataErrorOccurred={lanerror}
              style={{paddingTop: 0, paddingBottom: 0}}
              columnAutoWidth={true}
              columnHidingEnabled={false}
              showColumnLines={true}
              onExporting={onExporting}

          >
            <Column dataField="Дата" dataType="date" groupIndex={0}/>
            <Column dataField="Информация" groupIndex={2} sortIndex={2} caption={'-'}/>

            <Column dataField="Неделя" groupIndex={2}/>
            <Column dataField="ДеньНедели" groupIndex={3}/>
            <Column dataField="ПриемПищиНаименование" groupIndex={4}/>
            <Column dataField="Раздел"/>
            <Column dataField="Блюдо"/>
            <Column dataField="Выход"/>
            <Column dataField="Цена"/>
            <Column dataField="Калорийность"/>
            <Column dataField="Белки"/>
            <Column dataField="Жиры"/>
            <Column dataField="Углеводы"/>


            <Grouping autoExpandAll={false}/>
            <Paging pageSize={25}/>
            <Export enabled={true}/>
            <LoadPanel
                height={100}
                width={200}
                indicatorSrc={require('./load.gif')}

            />


          </DataGrid>


        </div>


        <div className={'content-block dx-card responsive-paddings'} style={{overflow: 'visible'}}>
          <div className={'title-table'}><b>ОШИБКИ В МЕНЮ</b></div>
          <div className={'blockid'}>Код пищеблока: {selectpisheblok}</div>
          <DataGrid
              dataSource={linkdataerror}
              showBorders={true}
              width='100%'
              allowColumnResizing={true}
              style={{paddingTop: 0, paddingBottom: 0}}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              showColumnLines={true}
              //dataRowRender={DataRow}
              hoverStateEnabled={true}
              onExporting={onExporting}
              onDataErrorOccurred={lanerror}
          >
            <Column dataField="Дата" fixed={true}/>
            <Column dataField="ПриемПищиНаименование" hidingPriority={9}/>
            <Column dataField="ПроверкаПредставление"/>
            <Column dataField="Примечание" hidingPriority={10}/>
            <ColumnChooser enabled={true} mode="select"/>
            <Export enabled={true}/>
            <Paging defaultPageSize={10}/>
            <Pager showPageSizeSelector={true} showInfo={true}/>
            <LoadPanel
                height={100}
                width={200}
                indicatorSrc={require('./load.gif')}

            />
          </DataGrid>


        </div>

        <div className={'content-block dx-card responsive-paddings'} style={{overflow: 'visible'}}>
          <div className={'title-table'}><b>СОБЛЮДЕНИЕ ТИПОВОГО МЕНЮ</b></div>
          <div className={'blockid'}>Код пищеблока: {selectpisheblok}</div>
          <DataGrid

              dataSource={sobludenietip}
              showBorders={true}
              width='100%'
              allowColumnResizing={true}
              style={{paddingTop: 0, paddingBottom: 0}}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              showColumnLines={true}
              //dataRowRender={DataRow}
              hoverStateEnabled={true}
              onExporting={onExporting}
              wordWrapEnabled={true}
              onRowClick={clickmenusab}
              onDataErrorOccurred={lanerror}
          >

            <HeaderFilter visible={true}>
              <Search enabled={true}/>
            </HeaderFilter>
            <Column dataField="Дата"/>
            <Column dataField="НомерДняВМеню"/>
            <Column dataField="ПроцентСоблюдения"
                    format="percent"
            />
            <Column dataField="Замечания"/>
            <Column caption="№" dataField="СсылкаНаТМСсылка"/>
            <ColumnChooser enabled={true} mode="select"/>
            <Export enabled={true}/>
            <Paging defaultPageSize={10}/>
            <Pager showPageSizeSelector={false} showInfo={true}/>
            <LoadPanel
                height={100}
                width={200}
                indicatorSrc={require('./load.gif')}

            />
          </DataGrid>

        </div>

        <div className={'content-block dx-card responsive-paddings'} style={{overflow: 'visible'}}>
          <div className={'title-table'}><b>АНКЕТА ПО РЕЙТИНГУ РОДИТЕЛЬСКОГО КОНТРОЛЯ</b></div>
          <div className={'blockid'}>Код пищеблока: {selectpisheblok}</div>
          <DataGrid
              dataSource={findex}
              showBorders={true}
              width='100%'
              allowColumnResizing={true}
              style={{paddingTop: 0, paddingBottom: 0}}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              showColumnLines={true}
              //dataRowRender={DataRow}
              hoverStateEnabled={true}
              onExporting={onExporting}
              wordWrapEnabled={true}
              onDataErrorOccurred={lanerror}
              onCellClick={perehod}
          >
            <HeaderFilter visible={true}>
              <Search enabled={true}/>
            </HeaderFilter>
            <Column dataField="Дата"/>
            <Column dataField="СвойствоНаименование"/>
            <Column dataField="ЗначениеСвойства"/>

            <ColumnChooser enabled={true} mode="select"/>
            <Export enabled={true}/>
            <Paging defaultPageSize={20}/>
            <Pager showPageSizeSelector={true} showInfo={true}/>
            <LoadPanel
                height={100}
                width={200}
                indicatorSrc={require('./load.gif')}

            />
          </DataGrid>

        </div>

        <div className={'content-block dx-card responsive-paddings'} style={{overflow: 'visible'}}>
          <div className={'title-table'}><b>КОЛИЧЕСТВО РЕСПОНДЕНТОВ В ОПРОСАХ</b></div>
          <div className={'blockid'}>Код пищеблока: {selectpisheblok}</div>
          <DataGrid
              dataSource={opros}
              showBorders={true}
              width='100%'
              allowColumnResizing={true}
              style={{paddingTop: 0, paddingBottom: 0}}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              showColumnLines={true}
              hoverStateEnabled={true}
              onExporting={onExporting}
              onDataErrorOccurred={lanerror}
              onRowClick={clickopros}
          >

            <Export enabled={false}/>
            <Paging defaultPageSize={10}/>

            <LoadPanel
                height={100}
                width={200}
                indicatorSrc={require('./load.gif')}

            />
          </DataGrid>
          <center><Button
                width={300}
                text="Посмотреть результат"
                type="default"
                stylingMode="contained"
                onClick={() => clickopros()}
             


            />
            </center>

<br></br>
          <div className={'title-table'}><b>ОЦЕНКИ В ПРИЛОЖЕНИИ "ОЦЕНИ ПИТАНИЕ" </b></div>
          <center><a href='https://op.cemon.ru'>https://op.cemon.ru/</a></center>
          <DataGrid
              dataSource={ocenki}
              showBorders={true}
              width='100%'
              allowColumnResizing={true}
              style={{paddingTop: 0, paddingBottom: 0}}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              showColumnLines={true}
              hoverStateEnabled={true}
              onExporting={onExporting}
              onDataErrorOccurred={lanerror}
          >
            <Column dataField="Дата" dataType="date" defaultSortOrder="desc"/>
            <Column dataField="КолвоОценок" caption="Респондентов"/>
            <Column dataField="Оценка" caption="Средняя оценка меню" dataType="number" format="0.#"/>

            
            <Export enabled={false}/>
            <Paging defaultPageSize={10}/>

            <LoadPanel
                height={100}
                width={200}
                indicatorSrc={require('./load.gif')}

            />
          </DataGrid>

        </div>


        <div className={'content-block dx-card responsive-paddings'} style={{overflow: 'visible'}}>
          <div className={'title-table'}><b>ЛОГ АВТОМАТИЗИРОВАННЫХ ЗАПРОСОВ</b></div>
          <div className={'blockid'}>Код пищеблока: {selectpisheblok}</div>
          <DataGrid
              dataSource={chtenielog}
              showBorders={true}
              width='100%'
              allowColumnResizing={true}
              style={{paddingTop: 0, paddingBottom: 0}}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              showColumnLines={true}
              //dataRowRender={DataRow}
              hoverStateEnabled={true}
              onExporting={onExporting}
              onDataErrorOccurred={lanerror}
          >
          
            <ColumnChooser enabled={true} mode="select"/>
            <Export enabled={true}/>
            <Paging defaultPageSize={10}/>
            <LoadPanel
                height={100}
                width={200}
                indicatorSrc={require('./load.gif')}

            />
          </DataGrid>

        </div>
        <div>
          <Popup
              width={'90%'}
              height={'95%'}
              showTitle={true}
              //title={menutitle}
              titleRender={renderTitle}
              dragEnabled={true}
              hideOnOutsideClick={true}
              visible={menuVisible}
              onHiding={handlePopupHidden}
              contentRender={rendermenuwin}
              showCloseButton={true}
          />

        </div>

        <div>
          <Popup
              width={'90%'}
              height={'95%'}
              showTitle={true}
              //titleRender ={rentitle}
              title={menutitlesab + ' Соответствие фактического и типового меню'}
              dragEnabled={true}
              hideOnOutsideClick={false}
              visible={menuVisiblesab}
              onHiding={handlePopupHiddensab}
              contentRender={rendermenuwinsab}
              showCloseButton={true}
              resizeEnabled={true}

          />
        </div>

        {/* Модальное окно результатов опроса */}
        {showPollResults && selectpisheblok && (
          <PollResults 
            foodBlockCode={selectpisheblok}
            onClose={handleClosePollResults}
          />
        )}






        <div>

          <Popup
              width={'50%'}
              height={'50%'}
              showTitle={true}
              title="Редактирование ссылки пищеблока"
              //titleRender={renderTitle}
              dragEnabled={true}
              //hideOnOutsideClick={true}
              visible={modlinkedit}
              onHiding={hidewineditlink}
              //contentRender={rendermenuwilinkedit}
              showCloseButton={true}
          >
            <div className={'diveditlink'}>
              <div className={'title-table'}><b>ВАЖНАЯ ИНФОРМАЦИЯ</b></div>
              <div className={'content-block dx-card responsive-paddings info'}>

                <i
                    className="dx-icon dx-icon-info"></i>По ссылке должен находиться файл findex.xlsx
              </div>

              <div className={'title-table'}><b>ИЗМЕНЕНИЕ ССЫЛКИ</b></div>
              <Pincode/>
              <TextBox
                  style={{width: '100%', display: 'inline-block', marginRight: '10px', marginTop: '10px'}}
                  defaultValue=""
                  placeholder='Введите новую ссылку'
                  onValueChanged={valueChangedlink}

                  valueChangeEvent="change"
              />
              <center>
                <Button
                    style={{marginTop: '10px', marginBottom: '10px'}}
                    //width={100}
                    text="Изменить ссылку"
                    type="success"
                    stylingMode="outlined"
                    onClick={otpraveditlink}
                    icon="edit"
                />
              </center>

              <div className={'soobsh'}>{resulteditlink}</div>
            </div>
          </Popup>


        </div>


        <div>
          <div>
            <Popup
                width={'90%'}
                height={'90%'}
                showTitle={true}
                //titleRender ={rentitle}
                title={'Заявка на дочтение ежедневного меню'}
                dragEnabled={true}
                hideOnOutsideClick={false}
                visible={modzaprosvid}
                onHiding={hideInfoModalWindowsMenu}
                // contentRender={rendermodzaprosvid}
                showCloseButton={true}
                resizeEnabled={true}

            >
              <div>

                <div>
                  <div className={'title-table'}><b>ВАЖНАЯ ИНФОРМАЦИЯ</b></div>
                  <div className={'content-block dx-card responsive-paddings info'}>

                    <i
                        className="dx-icon dx-icon-info"></i>Ограничение
                    запроса от одной образовательной организации - 1 раз в сутки. Период обработки запроса - 1 час и
                    более. <u><b>Уже
                    загруженные меню (присутствующие в базе ФЦМПО) не перезаписываются</b></u>. Чтение происходит
                    только по новым
                    меню. При необходимости удаления старого меню и дочтения нового – обратитесь к региональному
                    отвественному за питание.
                  </div>
                  <br></br>
                  <div className={'title-table'}><b>ЗАЯВКА НА ДОЧТЕНИЕ МЕНЮ В ПЕРИОД
                    С {selectstart.replace(pattern, ".")} ПО {selectend.replace(pattern, ".")}</b></div>
                  <div className={'content-block dx-card responsive-paddings'}>

                    <Pincode/>
                    <center><Button

                        text="ОТПРАВИТЬ ЗАЯВКУ НА ДОЧТЕНИЕ"
                        type="success"
                        stylingMode="outlined"
                        onClick={otpravdata}
                        icon="xlsxfile"

                        //icon="search"


                    />
                    </center>
                    <br></br>

                    <div className={'title-table'}><b>Результат предварительной проверки доступности файлов на сайте
                      пищеблока</b></div>
                    <DataGrid
                        dataSource={listpr}
                        showBorders={true}
                        width='100%'
                        allowColumnResizing={true}
                        showColumnLines={true}
                        wordWrapEnabled={true}
                        columnHidingEnabled={false}
                        onExporting={onExporting}
                    >
                      <Export enabled={true}/>
                      <Paging defaultPageSize={5}/>
                      <Pager
                          visible={true}

                          showInfo={true}
                          showNavigationButtons={false}/>
                      <LoadPanel
                          height={100}
                          width={200}
                          indicatorSrc={require('./load.gif')}

                      />
                    </DataGrid>


                  </div>


                  <div className={'title-table'}><b>СПИСОК ЗАПРОСОВ НА ДОЧТЕНИЕ ЕЖЕДНЕВНОГО МЕНЮ</b></div>
                  <DataGrid
                      dataSource={listzapros}
                      showBorders={true}
                      width='100%'
                      allowColumnResizing={true}
                      showColumnLines={true}
                      wordWrapEnabled={true}
                      //hoverStateEnabled={true}
                      //hoverStateEnabled={true}
                      //onDataErrorOccurred={lanerror}
                      columnHidingEnabled={false}
                      onExporting={onExporting}
                  >

                    <Paging defaultPageSize={5}/>
                    <Pager
                        visible={true}

                        showInfo={true}
                        showNavigationButtons={false}/>
                    <Export enabled={true}/>
                    <LoadPanel
                        height={100}
                        width={200}
                        indicatorSrc={require('./load.gif')}

                    />
                  </DataGrid>


                </div>

              </div>
            </Popup>
        
          </div>


        </div>


      </div>
  );
  }
}